if (!customElements.get('sterling-styling-row')) {
    customElements.define('sterling-styling-row', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('[data-styling-track]');
        const cards = Array.from(this.querySelectorAll('[data-styling-card]'));
        const controls = this.querySelector('[data-styling-controls]');
        if (!track || !controls || !cards.length) return;
        const previous = this.querySelector('[data-styling-previous]');
        const next = this.querySelector('[data-styling-next]');
        const status = this.querySelector('[data-styling-status]');
        const rtl = getComputedStyle(track).direction === 'rtl';
        const current = () => (rtl ? -track.scrollLeft : track.scrollLeft);
        let positions = [0];
        let index = 0;
        const sync = () => {
          const offset = current();
          index = positions.reduce((best, position, i) => Math.abs(position - offset) < Math.abs(positions[best] - offset) ? i : best, 0);
          previous.disabled = offset <= 2;
          next.disabled = offset >= positions[positions.length - 1] - 2;
          const label = positions.length > 1 ? this.dataset.positionLabel.replace('[current]', String(index + 1)).replace('[total]', String(positions.length)) : '';
          if (status.textContent !== label) status.textContent = label;
        };
        const move = target => {
          const position = positions[Math.max(0, Math.min(positions.length - 1, target))];
          track.scrollTo({ left: rtl ? -position : position, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        const build = () => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          const first = cards[0].getBoundingClientRect();
          positions = [0];
          cards.forEach(card => {
            const rect = card.getBoundingClientRect();
            const position = Math.min(max, Math.max(0, rtl ? first.right - rect.right : rect.left - first.left));
            if (position - positions[positions.length - 1] > 2) positions.push(position);
          });
          if (max - positions[positions.length - 1] > 2) positions.push(max);
          controls.hidden = positions.length < 2;
          sync();
        };
        previous.addEventListener('click', () => move(index - 1), { signal });
        next.addEventListener('click', () => move(index + 1), { signal });
        track.addEventListener('scroll', sync, { signal, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          let target;
          if (event.key === 'ArrowRight') target = index + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') target = index + (rtl ? 1 : -1);
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = positions.length - 1;
          else return;
          event.preventDefault();
          move(target);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!card) return;
          const first = cards[0].getBoundingClientRect();
          const rect = card.getBoundingClientRect();
          const offset = Math.min(track.scrollWidth - track.clientWidth, rtl ? first.right - rect.right : rect.left - first.left);
          track.scrollTo({ left: rtl ? -offset : offset, behavior: 'auto' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(build);
        this.resizeObserver.observe(track);
        build();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }
